import { Link, useNavigate } from "react-router-dom";
import { Book, BookOpen, Calendar, DollarSign, Inbox, TrendingUp } from "lucide-react";

const parseDate = (dateStr) => {
    const [day, month, year] = dateStr.trim().split('/');
    return new Date(year, month - 1, day);
  }

export const ProgramCards = ({ enrolment }) => {
  const navigate = useNavigate();
  
  const completionPercentage = enrolment?.totalSubjects > 0 
    ? (enrolment?.completedSubjects / enrolment?.totalSubjects) * 100
    : 0;

  const getProgressColor = () => {
    if (completionPercentage >= 70) return "bg-emerald-500";
    if (completionPercentage >= 30) return "bg-amber-500";
    return "bg-blue-500";
  };

  // Format currency
  const formatCurrency = (amount) => {
    return `$${amount?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  };

  // Calculate payment percentage
    function calculatePaymentPercent (enrolment) {
        return enrolment.totalInvoiced > 0
    ? Math.round((enrolment.totalReceipted / enrolment.totalInvoiced) * 100)
    : 0;
    }

    // Calculate progress percentage
    function calculateProgessPercentage (enrolment) {
      // if(enrolment.totalSubjects <= 0 ) return 0;

      const startDate = parseDate(enrolment.startDate);
      const endDate = parseDate(enrolment.endDate);
      const today = new Date();

      startDate.setHours(0,0,0,0);
      endDate.setHours(0,0,0,0);
      today.setHours(0,0,0,0);

      if(today >= endDate) return 100;

      if(today <=startDate) return 0;

      const totalDuration = endDate - startDate;
      const elapseDuration = today - startDate;

      const percentage = (elapseDuration / totalDuration) * 100;

      return Math.round(percentage);
    }

    const progress = enrolment ? calculateProgessPercentage(enrolment) : 0;

  return (
      <Link to={`/dashboard/programs/${enrolment.enrolmentId}/summary?uos=${enrolment.totalUOS}&subjects=${enrolment.totalSubjects}`}
      className="bg-white rounded-md border-l-4 border-blue-500 shadow-md p-4 cursor-pointer transition-shadow duration-200 flex-shrink-0 hover:shadow-xl">
      <div className="flex-1">
        {/* Header Row */}
        <div className="flex flex-row justify-between mb-3">
          <div className="bg-emerald-50 px-2.5 py-1 rounded-full">
            <span className="text-emerald-600 text-xs font-medium">
              {enrolment?.courseCode?.trim()}
            </span>
          </div>

          <div className="bg-amber-50 rounded-full px-2 py-0.5 flex flex-row items-center">
            <Book className="w-3 h-3 text-amber-600" />
            <span className="text-amber-600 text-xs ml-1 font-medium">
              {enrolment?.completedSubjects}/{enrolment?.totalSubjects}
            </span>
          </div>
        </div>

        {/* Course Name */}
        <h3 className="text-gray-800 text-base font-semibold mb-3 line-clamp-2">
          {enrolment?.courseName}
        </h3>

        {/* Date Row */}
        <div className="flex flex-row items-center mb-3">
          <div className="w-7 h-7 bg-gray-100 rounded-full flex items-center justify-center mr-2">
            <Calendar className="w-3.5 h-3.5 text-gray-600" />
          </div>
          <span className="text-gray-600 text-sm">
            {enrolment?.startDate} - {enrolment?.endDate}
          </span>
        </div>

        {/* Progress Bar */}
        
          <div className="mb-4">
            <div className="flex items-center justify-between mb-2">
              <span className="text-sm text-gray-600">Progress</span>
              <span className="text-sm text-gray-900">{progress}%</span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2 overflow-hidden">
              <div 
                className={`${progress >= 70 ? "bg-emerald-500" : progress >= 30 ? "bg-amber-500" : "bg-blue-500"}  h-full rounded-full transition-all`}
                style={{ width: `${progress}%` }}
              ></div>
            </div>
            {/* <div className="flex items-center gap-1 mt-1">
              <BookOpen className="w-3 h-3 text-gray-400" />
              <span className="text-xs text-gray-600">
                {enrolment.completedSubjects} of {enrolment.totalSubjects} subjects completed
              </span>
            </div> */}
          </div>

        {/* Stats */}
        {/* <div className="grid grid-cols-2 gap-4 mb-4 pb-4 border-b border-gray-100">
          <div>
            <div className="flex items-center gap-1 mb-1">
              <DollarSign className="w-4 h-4 text-gray-400" />
              <span className="text-xs text-gray-500">Payment</span>
            </div>
            <div className="text-sm text-gray-900">{formatCurrency(enrolment.totalReceipted)}</div>
            <div className="text-xs text-gray-500">of {formatCurrency(enrolment.totalInvoiced)}</div>
          </div>
          <div>
            <div className="flex items-center gap-1 mb-1">
              <TrendingUp className="w-4 h-4 text-gray-400" />
              <span className="text-xs text-gray-500">Attendance</span>
            </div>
            <div className="text-sm text-gray-900">{enrolment.overAllAttendance}%</div>
            <div className="text-xs text-gray-500">Overall</div>
          </div>
        </div> */}

        {/* Payment Progress Indicator */}
        {/* {enrolment.totalInvoiced > 0 && (
          <div className="mb-2">
            <span className="text-xs text-gray-600">Payment Progress</span>
            <div className="w-full bg-gray-200 rounded-full h-2 overflow-hidden mt-2">
              <div 
                className={`h-full rounded-full transition-all ${
                  calculatePaymentPercent(enrolment) === 100 ? 'bg-green-500' : 'bg-amber-500'
                }`}
                style={{ width: `${calculatePaymentPercent(enrolment)}%` }}
              ></div>
            </div>
          </div>
        )} */}
      </div>
    </Link>
  );
};

// Loading Skeleton Component
export const ProgramCardSkeleton = () => {
  return (
    <div className="bg-white rounded-lg border-gray-200 shadow-md p-4 mb-4 animate-pulse h-full">
      <div className="flex justify-between mb-3">
        <div className="h-6 w-20 bg-gray-200 rounded-full"></div>
        <div className="h-6 w-12 bg-gray-200 rounded-full"></div>
      </div>
      <div className="h-5 w-full bg-gray-200 rounded mb-2"></div>
      <div className="h-5 w-3/4 bg-gray-200 rounded mb-3"></div>
      <div className="flex items-center mb-3">
        <div className="w-7 h-7 bg-gray-200 rounded-full mr-2"></div>
        <div className="h-4 w-32 bg-gray-200 rounded"></div>
      </div>
      <div className="h-1.5 w-full bg-gray-200 rounded-full"></div>
    </div>
  );
};

// Empty State Component
export const EmptyState = ({ message = "No Programs Found" }) => {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-gray-500">
      <Inbox className="w-16 h-16 mb-4 text-gray-400" />
      <p className="text-lg text-gray-600">{message}</p>
    </div>
  );
};

export default ProgramCards;